import React, { useEffect, useState } from 'react';
import { api } from '@/api/client';
import OpenAPIButton from '@/components/OpenAPIButton';

export default function Home(){
  const [worked, setWorked] = useState<number | null>(null);
  useEffect(()=>{ api.get('/User/GetTodayResume').then(({data})=>{ setWorked(data?.TodayResume?.[0]?.worked ?? null); }).catch(()=>setWorked(null)); },[]);
  return <div>Dashboard — Ore lavorate oggi: <b>{worked ?? '-'}</b><div style={{marginTop:12}}><OpenAPIButton/></div></div>;
}
